import { render } from "./tax.vue?vue&type=template&id=3f11722f&scoped=true"
import script from "./tax.vue?vue&type=script&lang=js"
export * from "./tax.vue?vue&type=script&lang=js"

import "./tax.vue?vue&type=style&index=0&id=3f11722f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f11722f"]])

export default __exports__